// frontend/src/App.jsx
import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

import Header from './components/Header';
import Footer from './components/Footer';
import FloatingPreinvoiceCart from './components/FloatingPreinvoiceCart';
import BackToTopButton from './components/BackToTopButton';

import HomePage from './pages/HomePage';
import LoginPage from './pages/LoginPage';
import CategoryPage from './pages/CategoryPage';
import CategoryTreePage from './pages/CategoryTreePage';
import SubcategoryPage from './pages/SubcategoryPage';
import ProductPage from './pages/ProductPage';
import PreinvoicePage from './pages/PreinvoicePage';
import AccountPage from './pages/AccountPage';
import AboutPage from './pages/AboutPage';
import ContactPage from './pages/ContactPage';
import BrandPage from './pages/BrandPage';
import WeightCalculatorPage from './pages/WeightCalculatorPage';
import ProductCatalogsPage from './pages/ProductCatalogsPage';
import ProductCatalogDetailPage from './pages/ProductCatalogDetailPage';
import EngineeringLibraryPage from './pages/EngineeringLibraryPage';

import { PreinvoiceProvider } from './context/PreinvoiceContext';
import { WebAuthProvider } from './context/WebAuthContext';
import { ToastProvider } from './context/ToastContext';
import PreinvoiceDetailPage from "./pages/PreinvoiceDetailPage";
import RouteTracker from './components/tracking/RouteTracker';
import ScrollBehavior from './components/ScrollBehavior';

const App = () => {
  return (
    <Router>
      <ToastProvider>
        <WebAuthProvider>
          <PreinvoiceProvider>
            <div className="min-h-screen flex flex-col bg-gray-50">
              <ScrollBehavior />
              <RouteTracker />
              <Header />
              <FloatingPreinvoiceCart />
              <BackToTopButton />
              <div className="flex-1">
                <Routes>
                  <Route path="/" element={<HomePage />} />
                  <Route path="/login" element={<LoginPage />} />
                  <Route path="/category/:slug" element={<CategoryPage />} />
                  <Route path="/category-tree" element={<CategoryTreePage />} />
                  <Route path="/subcategory/:slug" element={<SubcategoryPage />} />
                  <Route path="/brand/:slug" element={<BrandPage />} />
                  <Route path="/product/:id" element={<ProductPage />} />
                  <Route path="/preinvoice" element={<PreinvoicePage />} />
                  <Route path="/weight-calculator" element={<WeightCalculatorPage />} />
                  <Route path="/product-catalogs" element={<ProductCatalogsPage />} />
                  <Route path="/product-catalogs/:id" element={<ProductCatalogDetailPage />} />
                  <Route path="/engineering-library" element={<EngineeringLibraryPage />} />
                  <Route path="/engineering-library/:id" element={<EngineeringLibraryPage />} />
                  <Route path="/account" element={<AccountPage />} />
                  <Route path="/about" element={<AboutPage />} />
                  <Route path="/contact" element={<ContactPage />} />
                  <Route path="/preinvoice/:id" element={<PreinvoiceDetailPage />} />
                </Routes>
              </div>
              <Footer />
            </div>
          </PreinvoiceProvider>
        </WebAuthProvider>
      </ToastProvider>
    </Router>
  );
};

export default App;
